import { render, staticRenderFns } from "./StanleyExampleQuestions.vue?vue&type=template&id=70c81510&scoped=true"
import script from "./StanleyExampleQuestions.vue?vue&type=script&lang=js"
export * from "./StanleyExampleQuestions.vue?vue&type=script&lang=js"
import style0 from "./StanleyExampleQuestions.vue?vue&type=style&index=0&id=70c81510&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c81510",
  null
  
)

export default component.exports